var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { useEffect } from 'react';
import { useFormState, useWatch } from 'react-hook-form';
import { useLocation } from 'react-router-dom';
import { SwapFormKey } from './types';
const formValueKeys = [
    SwapFormKey.FromAmount,
    SwapFormKey.FromChain,
    SwapFormKey.FromToken,
    SwapFormKey.ToAddress,
    SwapFormKey.ToChain,
    SwapFormKey.ToToken,
];
export const URLSearchParamsBuilder = () => {
    const { pathname } = useLocation();
    const touchedFields = __rest(useFormState().touchedFields, []);
    const values = useWatch({ name: formValueKeys });
    useEffect(() => {
        const url = new URL(window.location);
        formValueKeys.forEach((key, index) => {
            if (touchedFields[key] && values[index]) {
                url.searchParams.set(key, values[index]);
            }
            else if (url.searchParams.has(key) && !values[index]) {
                url.searchParams.delete(key);
            }
        });
        url.searchParams.sort();
        window.history.replaceState(window.history.state, '', url);
    }, [pathname, touchedFields, values]);
    return null;
};
